import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7873a6e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-actions" }

import { ref } from "vue";
import { ActivityService } from "@/services/ActivityService";
import { useToast } from "@/services/useToast";

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityCreator',
  props: {
    publicReference: {}
  },
  emits: ["activity-created"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const activityService = new ActivityService("/admin/activities");
const { showToast } = useToast();
const newComment = ref("");

async function createComment() {
  try {
    await activityService.createAdminComment(
      newComment.value,
      props.publicReference
    );
    newComment.value = "";
    emit("activity-created");
    showToast("Komment elküldve");
  } catch {
    showToast("Komment küldése sikertelen", "error");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "comment-box mt-4",
    elevation: "1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_textarea, {
        class: "mt-4",
        modelValue: newComment.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newComment).value = $event)),
        label: "Írjon kommentet",
        rows: "2",
        "auto-grow": "",
        variant: "outlined",
        "hide-details": ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: createComment
        }, {
          default: _withCtx(() => [
            _createTextVNode("Küldés")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})